<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'MOBILE_USERS', url: '/admin/mobile-users' },
    { label: 'TASKS' }
  ]"
></breadcrumbs>

<page-header title="TASKS"></page-header>

<card>
  <div class="is-flex">
    <div class="is-flex" style="width: 350px">
      <div class="field is-narrow mr-2">
        <label class="label" translationEditableDirective="USERNAME">{{
          'USERNAME' | translate
        }}</label>
        <div class="control">
          {{ getField(['username']) }}
        </div>
      </div>
      <div class="field is-narrow mr-2">
        <label class="label" translationEditableDirective="FIRST_NAME">{{
          'FIRST_NAME' | translate
        }}</label>

        <div class="control">
          {{ getField(['firstName']) }}
        </div>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="LAST_NAME">{{
          'LAST_NAME' | translate
        }}</label>
        <div class="control">
          {{ getField(['lastName']) }}
        </div>
      </div>
    </div>
  </div>
</card>

<app-table
  [isLoading]="tasksAreLoading"
  [totalItems]="taskState.get('total')"
  [totalResults]="
    filters.length ? taskState.get('filtered') : taskState.get('total')
  "
  [itemsPerPage]="taskState.getIn(['pagination', 'page_size'])"
  (onPageChange)="handlePageChange($event)"
  [rows]="taskState.get('data')"
  [columns]="columns"
  [showFilter]="true"
  [showReload]="true"
  (onFilterChange)="handleFilterChange($event)"
  [filters]="filters"
  [currentPage]="taskState.getIn(['pagination', 'page'])"
  [sort]="taskState.getIn(['pagination', 'sort'])"
  [orderBy]="taskState.getIn(['pagination', 'order_by'])"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <button
        type="button"
        class="button is-small is-info"
        translationEditableDirective="AUTOASSIGN_TASKS"
        (click)="autoAssign()"
        [disabled]="autoAssignLoading"
      >
        {{ 'AUTOASSIGN_TASKS' | translate }}
      </button>
    </div>
  </ng-template>
  <ng-template let-row="row" let-index="index" #type>
    <span
      [translationEditableDirective]="row.getIn(['type', 'translationKey'])"
      >{{
        row.getIn(['type', 'translationKey'])
          | translate : { defaultValue: row.getIn(['type', 'title']) }
      }}</span
    >
  </ng-template>
  <ng-template let-row="row" let-index="index" #objectType>
    <span
      [translationEditableDirective]="
        row.getIn(['objectType', 'translationKey'])
      "
      >{{
        row.getIn(['objectType', 'translationKey'])
          | translate : { defaultValue: row.getIn(['objectType', 'title']) }
      }}</span
    >
  </ng-template>
  <ng-template let-row="row" let-index="index" #code>
    <a
      [routerLink]="[
        '/',
        row.getIn(['objectType', 'name']) === 'BUSINESS'
          ? 'businesses'
          : 'properties',
        row.getIn(['objectLabelId', 'id'])
      ]"
      >{{ row.getIn(['objectLabelId', 'label']) }}</a
    >
  </ng-template>
</app-table>
